import { ReactNode, createContext } from "react";
import useTipoCusto, {TipoCustoType, CreateTipoCustoType, UpdateTipoCustoType} from "../context/hooks/useTipoCusto"

interface TipoCustoContextProviderProps {
    children: ReactNode;
}

export interface TipoCustoContextData {
    getAllTipoCustoPaged: (
        pageNumber: number,
        pageSize: number,
        empresaId?: number,
        isFinancial?: boolean,
        description?: string,
    ) => Promise<TipoCustoType[] | null>;
    setTipoCusto: any;
    tipoCusto: TipoCustoType;
    setListTipoCusto: any;
    listTipoCusto: TipoCustoType[];
    setInitialListTipoCusto: any;
    initialListTipoCusto: TipoCustoType[];
    setTipoCustoPageCount: any;
    tipoCustoPageCount: number;
    createTipoCusto: (createTipoCustoType: CreateTipoCustoType) => Promise<CreateTipoCustoType | null>;
    updateTipoCusto: (updateUserTypeType: UpdateTipoCustoType) => Promise<UpdateTipoCustoType | null>;
    deleteTipoCusto: (id: number) => Promise<TipoCustoType | null>;
}

const initialState: TipoCustoContextData = {
    getAllTipoCustoPaged: async (
        pageNumber: number,
        pageSize: number,
        empresaId?: number,
        isFinancial?: boolean,
        description?: string,
    ) => {
        return Promise.resolve(null);
    },
    setTipoCusto: () => { },
    tipoCusto: {
        id: 0,
        description: "",
        value: 0,
        isFinancial: false,
        isFixo: false,
        empresaId: 0,
    },
    setListTipoCusto: () => {},
    listTipoCusto: [],
    setInitialListTipoCusto: () => {},
    initialListTipoCusto: [],
    setTipoCustoPageCount: () => {},
    tipoCustoPageCount: 0,
    createTipoCusto: async (createTipoCustoType: CreateTipoCustoType) => {
        return Promise.resolve(null);
    },
    updateTipoCusto: async (updateTipoCustoType: UpdateTipoCustoType) => {
        return Promise.resolve(null);
    },
    deleteTipoCusto: async (id: number) => {
        return Promise.resolve(null);
    },
};

export const TipoCustoContext =
    createContext<TipoCustoContextData>(initialState);

export default function TipoCustoContextProvider({
    children,
}: TipoCustoContextProviderProps) {
    const {
        getAllTipoCustoPaged,
        createTipoCusto,
        updateTipoCusto,
        deleteTipoCusto,
        tipoCusto,
        setTipoCusto,
        setListTipoCusto,
        listTipoCusto,
        initialListTipoCusto,
        setInitialListTipoCusto,
        setTipoCustoPageCount,
        tipoCustoPageCount,
    } = useTipoCusto();

    return (
        <TipoCustoContext.Provider
            value={{
                getAllTipoCustoPaged,
                createTipoCusto,
                updateTipoCusto,
                deleteTipoCusto,
                tipoCusto,
                setTipoCusto,
                setListTipoCusto,
                listTipoCusto,
                initialListTipoCusto,
                setInitialListTipoCusto,
                setTipoCustoPageCount,
                tipoCustoPageCount,
            }}
        >
            {children}
        </TipoCustoContext.Provider>
    );
}